import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import type { Object3D } from 'three';

/** The opponent's model, made in Blender by art/boxer.py and shipped with the game. */
export async function loadBoxerModel(): Promise<Object3D> {
  const gltf = await new GLTFLoader().loadAsync(`${import.meta.env.BASE_URL}models/bear.glb`);
  return gltf.scene;
}
